import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OgmaLogo } from "@/components/OgmaLogo";
import { LoginForm } from "@/features/auth/LoginForm";
import { RegisterForm } from "@/features/auth/RegisterForm";

type Mode = "login" | "register";

export function AuthPage() {
  const { t } = useTranslation();
  const [mode, setMode] = useState<Mode>("login");

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-muted/40">
      <div className="flex w-80 flex-col items-center gap-8 rounded-xl border border-border bg-card px-10 py-12 shadow-sm">
        <div className="flex flex-col items-center gap-2">
          <OgmaLogo size={48} />
          <p className="text-sm text-muted-foreground">{t("auth.tagline")}</p>
        </div>
        {mode === "login" ? (
          <LoginForm onSwitch={() => setMode("register")} />
        ) : (
          <RegisterForm onSwitch={() => setMode("login")} />
        )}
      </div>
    </div>
  );
}
